"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logExperimentalComponent = void 0;
var LoggingUtils_1 = require("./LoggingUtils");
var logExperimentalComponent = function (componentName) {
    var preamble = "EXPERIMENTAL COMPONENT USED \u2013 " + componentName;
    var componentMsg = "The %c" + componentName + "%c component is an experimental component.";
    var warningMsg = '\n\n' +
        'Ferris experimental components...\n\n' +
        '• are subject to be removed from the system at any time without notice\n' +
        '• are subject to being renamed at any time without notice\n' +
        '• may not have a consistent props interface\n' +
        '• may not be stable\n' +
        '• may not have complete design specs\n' +
        '• may not support all edge cases\n' +
        '• may be missing features\n' +
        '• may contain major bugs\n\n' +
        'Experimental components can be used in Production environments but should be used with a full understanding of this risk.';
    LoggingUtils_1.logConsoleMessage(preamble, LoggingUtils_1.ConsoleMessageLevels.WARN, componentMsg + " " + warningMsg);
};
exports.logExperimentalComponent = logExperimentalComponent;
